import React from 'react';
import PropTypes from 'prop-types';

const Xls = ({ theme, fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 8.0175V6L10.5 1.5H4.5C4.10218 1.5 3.72065 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V8.0175H1.5675V13.875H3V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72065 16.342 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V13.875H16.4325V8.0175H15ZM4.5 3H9.75V6.75H13.5V8.0175H4.5V3ZM10.7925 12.27V13.0725H8.07V8.79H9V12.27H10.7925ZM4.425 13.0725H3.3375L4.89 10.875L3.435 8.79H4.5L5.475 10.2525L6.45 8.79H7.545L6.1125 10.8675L7.665 13.0725H6.57L5.4975 11.505L4.425 13.0725ZM13.5 15H4.5V13.875H13.5V15ZM12.945 13.1475C12.6121 13.1622 12.2796 13.1093 11.9677 12.992C11.6557 12.8747 11.3708 12.6954 11.13 12.465L11.6325 11.775C11.808 11.958 12.0187 12.1036 12.2521 12.2029C12.4854 12.3021 12.7364 12.353 12.99 12.3525C13.4925 12.3525 13.74 12.1125 13.74 11.8725C13.74 11.6325 13.365 11.445 12.87 11.325C12.1725 11.1675 11.2725 10.9725 11.2725 10.02C11.2725 9.3075 11.8875 8.73 12.9 8.73C13.5105 8.70623 14.1068 8.9184 14.565 9.3225L14.055 9.99C13.7202 9.68719 13.2839 9.52123 12.8325 9.525C12.42 9.525 12.2025 9.705 12.2025 9.96C12.2025 10.215 12.5625 10.335 13.0575 10.455C13.7625 10.6125 14.6625 10.8225 14.6625 11.775C14.6625 12.555 14.1 13.1475 12.945 13.1475Z"
      fill={fill || theme.COLORS.primary}
    />
  </svg>
);

Xls.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Xls;
